import { useContext } from "react";

import { TApiButtonCommandFn } from ".";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { EXPECTED_ACTION_ERROR } from "containers/DynamicForm/useButtonAction";
import { useDirectUpload, useModal } from "modules";

import { find, map } from "lodash-es";

export const useUploadDocumentsToCloud = () => {
  const { form, inputs } = useContext(DynamicFormContext);
  const { uploadFile } = useDirectUpload();
  const openModal = useModal();

  const uploadDocumentsToCloud: TApiButtonCommandFn = async commandArgs => {
    const commandArgument = commandArgs?.[0];
    const fileInput = find(inputs, { key: commandArgument?.source });
    if (!fileInput) {
      return;
    }

    try {
      // Direct upload each file
      const signedBlobIds = await Promise.all(map(fileInput?.files, file => uploadFile(file)));

      // Set array of signedBlobId to input value for executeGroupApi
      form.onChange({
        target: { id: fileInput.id, value: signedBlobIds },
      });

      return signedBlobIds;
    } catch (error) {
      openModal("DocumentUploadErrorModal");
      throw Error(EXPECTED_ACTION_ERROR);
    }
  };

  return uploadDocumentsToCloud;
};
